import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { zAny, zArr, zNum, zObj, zStr } from "./zodWrapper.js";
export const DbDataReport = zObj({
    columns: zArr(zStr()),
    data: zArr(zArr(zAny())),
});
export var DbDataReportType;
(function (DbDataReportType) {
    DbDataReportType[DbDataReportType["OPMODE_COMPARISON"] = 0] = "OPMODE_COMPARISON";
    DbDataReportType[DbDataReportType["USER_ACTIVITY"] = 1] = "USER_ACTIVITY";
})(DbDataReportType || (DbDataReportType = {}));
export const DbDataReportTypeEnum = z.nativeEnum(DbDataReportType);
export const GetDbDataReportArgs = zObj({
    type: DbDataReportTypeEnum,
    args: zAny(),
});
export const FuelReportArgs = z.object({ plantId: zNum(), t1: ZDate, t2: ZDate });
//# sourceMappingURL=dbreport.js.map